export class DNSQueryFailedError extends AggregateError {
  static name = 'DNSQueryFailedError'
  name = 'DNSQueryFailedError'
}
